module.exports = __webpack_public_path__ + "static/media/book.fa2221c4.svg";